import React, {Component} from 'react'
import Select from 'react-select';
import { Link } from 'react-router-dom';
import makeAnimated from 'react-select/lib/animated';

class TagSelector extends Component {
    height = 0
    tagSelector = React.createRef()

    componentDidMount() {
        window.addEventListener('resize', this.onResize)
        this.height = this.tagSelector.current.offsetHeight
        if (this.props.onHeightChange && typeof this.props.onHeightChange === 'function') {
            this.props.onHeightChange(this.height)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize)
    }

    onResize = () => {
        if (this.height !== this.tagSelector.current.offsetHeight) {
            this.height = this.tagSelector.current.offsetHeight
            if (this.props.onHeightChange && typeof this.props.onHeightChange === 'function') {
                this.props.onHeightChange(this.height)
            }
        }
    }

    render() {
        const {changeParent, handleChange, selectedTags, selectedParent, parentTags, hide} = this.props
        const reducer = (all, parentTag) => {
            if (parentTag.childrens) {
                Object.keys(parentTag.childrens).forEach(tag => {
                    if (!all[tag]) {
                        all[tag] = parentTag.childrens[tag]
                    } else {
                        all[tag] += parentTag.childrens[tag]
                    }
                })
            }
            return all
        }
        let allTags = false
        if (selectedParent.value !== 'All 3D renderings') {
            const parentTag = parentTags.find(parentTag => parentTag._id === selectedParent.value)
            if (parentTag && parentTag.childrens) {
                allTags = parentTag.childrens
            }
        } else {
            allTags = parentTags.reduce(reducer, {})
        }
        const classN = ['tag_selector']
        if (hide) {
            classN.push('hide')
        }
        return (
            <div className={classN.join(' ')} ref={this.tagSelector}>
                <div className="tag_select">
                    <Select
                        closeMenuOnSelect
                        components={makeAnimated()}
                        isMulti={false}
                        value={selectedParent}
                        options={
                            [{ value: 'All 3D renderings', label: 'All 3D renderings' }, ...parentTags.map(parentTag => ({ value: parentTag._id, label: `${parentTag.name} (${Object.keys(parentTag.childrens).reduce((a, i) => parentTag.childrens[i] + a, 0)})` }))]
                        }
                        className="select"
                        classNamePrefix="select_child"
                        placeholder="Catégorie"
                        isSearchable
                        noOptionsMessage={() => "Pas de catégorie"}
                        onChange={changeParent}
                    />
                </div>
                {allTags && false && (
                    <div className="tag_select">
                        <h3>Tags: </h3>
                        <Select
                            closeMenuOnSelect
                            components={makeAnimated()}
                            isMulti
                            value={selectedTags.map(selectedTag => ({ value: selectedTag, label: selectedTag }))}
                            options={
                                Object.keys(allTags).map(tag => ({ value: tag, label: `${tag} ${allTags[tag]}` }))
                            }
                            className="select"
                            classNamePrefix="select_child"
                            placeholder="Tags"
                            isSearchable
                            noOptionsMessage={() => "Pas de sous catégorie"}
                            onChange={handleChange}
                        />
                    </div>
                )}
            </div>
        )
    }
}

export default TagSelector
